import { State as NetworkStatusState } from "@client/reducers/network-status-reducer";
import { Selector } from "@ngrx/store";
export const getIsOnline: Selector<NetworkStatusState, boolean> = (state: NetworkStatusState) => state.isOnline;
